import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { ISubscriptionHistory, defaultValue } from 'app/shared/model/subscription-history.model';

export const ACTION_TYPES = {
  FETCH_SUBSCRIPTIONHISTORY_LIST: 'subscriptionHistory/FETCH_SUBSCRIPTIONHISTORY_LIST',
  FETCH_SUBSCRIPTIONHISTORY: 'subscriptionHistory/FETCH_SUBSCRIPTIONHISTORY',
  CREATE_SUBSCRIPTIONHISTORY: 'subscriptionHistory/CREATE_SUBSCRIPTIONHISTORY',
  UPDATE_SUBSCRIPTIONHISTORY: 'subscriptionHistory/UPDATE_SUBSCRIPTIONHISTORY',
  DELETE_SUBSCRIPTIONHISTORY: 'subscriptionHistory/DELETE_SUBSCRIPTIONHISTORY',
  RESET: 'subscriptionHistory/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ISubscriptionHistory>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type SubscriptionHistoryState = Readonly<typeof initialState>;

// Reducer

export default (state: SubscriptionHistoryState = initialState, action): SubscriptionHistoryState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_SUBSCRIPTIONHISTORY):
    case REQUEST(ACTION_TYPES.UPDATE_SUBSCRIPTIONHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_SUBSCRIPTIONHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY):
    case FAILURE(ACTION_TYPES.CREATE_SUBSCRIPTIONHISTORY):
    case FAILURE(ACTION_TYPES.UPDATE_SUBSCRIPTIONHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_SUBSCRIPTIONHISTORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_SUBSCRIPTIONHISTORY):
    case SUCCESS(ACTION_TYPES.UPDATE_SUBSCRIPTIONHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_SUBSCRIPTIONHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/subscription-histories';

// Actions

export const getEntities: ICrudGetAllAction<ISubscriptionHistory> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY_LIST,
  payload: axios.get<ISubscriptionHistory>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<ISubscriptionHistory> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_SUBSCRIPTIONHISTORY,
    payload: axios.get<ISubscriptionHistory>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<ISubscriptionHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_SUBSCRIPTIONHISTORY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<ISubscriptionHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_SUBSCRIPTIONHISTORY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<ISubscriptionHistory> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_SUBSCRIPTIONHISTORY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
